import "../assets/scss/global.scss"
//import logo from "../assets/img/logo.svg";
import logo from "../assets/img/logo-w.png";
import hamburger from "../assets/img/hamburger-w.png";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Link } from "react-router-dom";

import userIcon from '../assets/img/user_icon_sm.svg';
import authIcon from '../assets/img/auth_icon.png';
import unsubscribeIcon from '../assets/img/unsubscribe_icon.png';
import logoutIcon from '../assets/img/logout_icon.svg';
import { useDispatch } from "react-redux";
import { logoutAction } from "../redux/action";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { GET_USER, REFRESH_TOKEN_API_URL, UNSUBSCRIBE_USER } from "../action/apiPath";
import { CallWithAuth } from "../action/apiActions";
import { toast, ToastContainer } from "react-toastify";
import { errorMessageCreate } from "../util/custom";
import { showToast } from "../util/toastHelper";
import { DOCTORASSESMENTINFORMATIONPAGE, PATIENTRELATIVESINFORMATION } from "../util/path";
import axios from "axios";
import IntercomProvider from "./IntercomProvider/IntercomProvider";
import { Cookie } from "../util/cookie";

const MySwal = withReactContent(Swal);

const Header = () => {

    const location = useLocation();

    const navigate = useNavigate()

    const [isSticky, setIsSticky] = useState(false);

    const [menuBar, setMenuBar] = useState(false);

    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // ✅ Add initials state
    const [initials, setInitials] = useState("");
    const [userData, setUserData] = useState(null);
    const [avatarLoading, setAvatarLoading] = useState(true);


    // ✅ new useEffect: profileUpdated event listen
    useEffect(() => {
        const loadUserFromStorage = () => {
            const storedUser = localStorage.getItem('userCreateAccount');
            if (storedUser) {
                const user = JSON.parse(storedUser);
                setUserData(user);

                if (user.profile_image) {
                    setInitials(null);
                    return;
                }

                // initials 
                const fullName = `${user.first_name || ""} ${user.last_name || ""}`.trim();
                let userInitials = "";

                if (fullName) {
                    const parts = fullName.split(" ");
                    if (parts.length > 1) {
                        userInitials = (parts[0][0] + parts[1][0]).toUpperCase();
                    } else {
                        userInitials = fullName.substring(0, 2).toUpperCase();
                    }
                } else {
                    const email = user.email || "";
                    const username = email.split("@")[0] || "";
                    userInitials = username.substring(0, 2).toUpperCase();
                }

                setInitials(userInitials);
            }
        };

        // load user from localstorage 1st time
        // loadUserFromStorage();

        // when profileUpdated event fire then data load
        window.addEventListener("profileUpdated", loadUserFromStorage);

        return () => {
            window.removeEventListener("profileUpdated", loadUserFromStorage);
        };
    }, []);

    const getAcceesToken = async () => {
        const refreshToken = Cookie.getCookie("refreshToken");
        if (!refreshToken) {
            return false;
        }

        try {
            setIsLoading(true);
            const response = await axios.post(REFRESH_TOKEN_API_URL, {
                refresh_token: refreshToken
            }, {
                'Content-Type': "application/json"
            });
            setIsLoading(false);

            if (response?.data?.data?.access_token) {
                localStorage.setItem("accessToken", response?.data?.data?.access_token);
                fetchData();
                return true;
            } else {
                return false;
            }

        } catch (e) {
            setIsLoading(false);
            return false;
        }
    }

    const fetchData = async () => {
        const isTokenAvailable = localStorage.getItem('accessToken');
        const initialized = Cookie.getCookie("initialized");
        if (isTokenAvailable && initialized) {
            const header = {
                headers: {
                    Authorization: `Bearer ${isTokenAvailable}`,
                },
            };

            try {
                setAvatarLoading(true);
                const response = await axios.get(GET_USER, header);
                if (response.status === 200 || response.status === 201) {
                    const fullName = `${response?.data?.data?.first_name || ""} ${response?.data?.data?.last_name || ""}`.trim();
                    let userInitials = "";

                    if (fullName) {
                        const parts = fullName.trim().split(" ");
                        if (parts.length > 1) {
                            userInitials = (parts[0][0] + parts[1][0]).toUpperCase();
                        } else {
                            userInitials = fullName.substring(0, 2).toUpperCase();
                        }
                    } else {
                        const email = response?.data?.data?.email || "";
                        const username = email.split("@")[0] || "";
                        userInitials = username.substring(0, 2).toUpperCase();
                    }

                    setUserData(response?.data?.data)
                    setInitials(userInitials); // ✅ store in state
                    localStorage.setItem("userCreateAccount", JSON.stringify(response?.data?.data));
                    localStorage.setItem("userCreateAccountInfo", JSON.stringify(response?.data?.data?.info));
                    
                    if (location.pathname.startsWith('/patient-report-information/') || location.pathname.startsWith('/patient-report-information-template/')) {
                        if (response?.data?.data?.isAllReportExhausted) {
                            localStorage.setItem('isReportLimitReached', 1);
                        } else {
                            localStorage.removeItem('isReportLimitReached');
                        }
                    }

                    // loc
                } else {
                    console.warn("Unexpected status:", response.status);
                }

                setIsLoggedIn(true);
            } catch (err) {
                if (err.response?.status === 401) {
                    const resp = await getAcceesToken();
                    if (!resp) {
                        localStorage.clear();
                        window.location.href = "/login"
                    }
                }
                console.error("Error:", err.response);
            } finally {
                setAvatarLoading(false); // ✅ 
            }
        } else {
            Cookie.setNonPersistentCookie('initialized', '1');
            const resp = await getAcceesToken();
            if (!resp) {
                localStorage.clear();
                setIsLoggedIn(false);
                setAvatarLoading(false);
            }
        }
    };

    useEffect(() => {
        fetchData();
    }, [location]);

    useEffect(() => {
        const handleScroll = () => {
            const top = window.scrollY;
            if (top > 0) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []); // Empty dependency array ensures this effect runs once when the component mounts


    const login = () => {
        navigate('/login')
    }

    const disptach = useDispatch()

    const logout = () => {
        localStorage.clear();
        Cookie.deleteCookie("refreshToken");
        navigate('/')
        disptach(logoutAction())
    }

    const home = () => {
        navigate('/')
    }


    // console.log('location.pathname ',location.pathname );





    return (
        <>
            {isLoading && (
                // <><h1 className="text-center">Report loading...</h1></>
                <>
                    <div className="full-page-loader">
                        <div className="loader"></div>
                    </div>
                </>
            )}
            <IntercomProvider />
            <header className={`site_header ${isSticky ? 'sticky_header' : ''}`}>
                <div className="site_container">
                    <div className="site_navbar">
                        <div className="site_brand">
                            <a onClick={() => home()}>
                                <img src={logo} alt="" />
                            </a>
                        </div>


                        <div className={menuBar ? "site_menus menu_show" : "site_menus"}>
                            <ul className="site_menu_bar">
                                <li className={location.pathname === '/' ? 'active_page' : ''}><Link to="/">Home</Link></li>
                                <li className={location.pathname === '/about' ? 'active_page' : ''}><Link to="/about">About Us</Link></li>
                                <li className={location.pathname === '/services' ? 'active_page' : ''}><Link to="/services">Services</Link></li>
                                <li className={location.pathname === '/contact-us' ? 'active_page' : ''}><Link to="/contact-us">Contact Us</Link></li>
                                {/* <li><Link to={'/patient-information'}>Patient Information</Link></li> */}
                                {localStorage.getItem('accessToken') ? <li className={location.pathname === '/patient-information' || location.pathname.startsWith(`/${PATIENTRELATIVESINFORMATION}/`) || location.pathname.startsWith('/patient-report-information/') || location.pathname.startsWith(`/${DOCTORASSESMENTINFORMATIONPAGE}/`) ? 'active_page' : ''}><Link to="/patient-information">Patient Information</Link></li> : null}
                            </ul>



                            {localStorage.getItem('accessToken') != null ? <>
                                <div className="user_panel">
                                    <div className="avatar" style={{ cursor: "pointer" }}>
                                        {avatarLoading ? (
                                            // ✅ loader show
                                            <div className="avatar-loader"></div>
                                        ) : userData?.profile_image ? (
                                            <img
                                                src={userData.profile_image}
                                                alt="Profile"
                                                style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                                            />
                                        ) : (
                                            <span>{initials}</span>
                                        )}
                                    </div>
                                    <div className="user_drop">
                                        <ul>
                                            <li><Link to={'/create-account'}><img src={userIcon} alt="" /> <span>
                                                Profile</span></Link>
                                            </li>
                                            <li><Link to={'/change-password'}><img src={userIcon} alt="" /> <span>
                                                Change Password</span></Link>
                                            </li>
                                            <li><Link to={'/two-step-authentication'}>
                                                <img src={authIcon} alt="" />
                                                <span>
                                                    Google Autheticator</span>
                                            </Link>
                                            </li>
                                            <li> <Link
                                                to={userData?.subscription === null ? "/subscription" : "/unsubscribe"}
                                            >
                                                <img src={unsubscribeIcon} alt="" />
                                                <span>
                                                    {/* Unsubscribe */}
                                                    {userData?.subscription === null ? "Subscribe" : "Manage Subscription"}
                                                </span>
                                            </Link>
                                            </li>
                                            <li><a style={{ cursor: 'pointer' }} onClick={() => logout()}><img src={logoutIcon} alt="" /> <span>Logout</span></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </> : <>
                                <div className="login_btns">
                                    <Link to={'/signup'} className="solid_cta cta_white"> Sign up</Link>
                                    <Link to={'/login'} className="solid_cta cta_primary"> Login</Link>
                                </div>
                            </>}


                        </div>
                        {/* <span className={menuBar ? "menu_toggler toggled" : "menu_toggler"} onClick={() => setMenubar(!menuBar)}>
                            <span></span>
                        </span> */}

                        <div className="site_navbar">
                            <button className={menuBar ? "menu-toggler toggled" : "menu-toggler formobile"} onClick={() => setMenuBar(!menuBar)}>
                                <img src={hamburger} alt="" />
                            </button>
                        </div>
                    </div>
                </div>
            </header>
            <ToastContainer />
        </>
    )
}

export default Header
